import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ThemeService } from '../../services';
import { RouterModule } from '@angular/router';

export interface NavLink {
  label: string;
  path: string;
}

export interface NavSubGroup {
  label?: string;
  links: NavLink[];
}

export interface NavGroup {
  category: string;
  subGroups: NavSubGroup[];
}

@Component({
  selector: 'lib-nav-links',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterModule],
  template: `
    <div class="flex flex-wrap gap-8 md:gap-16">
      <div *ngFor="let group of groups" class="flex flex-col min-w-[140px] flex-1 sm:flex-none">
        <h3 *ngIf="(isDesktop$ | async) === false" class="text-xs font-bold uppercase tracking-widest text-gray-500 mb-4 border-b border-gray-100 pb-2">
          {{ group.category }}
        </h3>
        <div [ngClass]="(isDesktop$ | async) ? 'flex-row' : 'flex-col'" class="flex gap-6">
          <div *ngFor="let subGroup of group.subGroups" class="flex flex-col items-start gap-1">
            <span *ngIf="subGroup.label" class="text-[10px] font-bold uppercase tracking-wider text-gray-400 px-2">
              {{ subGroup.label }}
            </span>
            <nav class="flex flex-col items-start gap-1 w-full">
              <a *ngFor="let link of subGroup.links"
                 mat-button
                 [routerLink]="link.path"
                 class="">
                <span class="!text-sm">{{ link.label }}</span>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  `
})
export class NavLinksComponent {
  private readonly themeService = inject(ThemeService);
  readonly isDesktop$ = this.themeService.breakpoints.isDesktop$;

  @Input() groups: NavGroup[] = [];
}
